import React from "react";
import { PeekAccordionCard, PeekBox, PeekRadio, PeekStack, PeekTypography, useTheme, } from "@piiqtechnologies/ui-components";
const SELECTED_BACKGROUND = "#F5FEFD";
const RADIO_SIZE = 16;
const RADIO_DOT_SIZE = 10;
const RadioMark = ({ borderColor, dotColor }) => (React.createElement(PeekBox, { sx: {
        width: RADIO_SIZE,
        height: RADIO_SIZE,
        borderRadius: "50%",
        border: `1px solid ${borderColor}`,
        backgroundColor: "common.white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    } }, dotColor && (React.createElement(PeekBox, { sx: { width: RADIO_DOT_SIZE, height: RADIO_DOT_SIZE, borderRadius: "50%", backgroundColor: dotColor } }))));
export const FormatOptionCard = ({ value, title, description, selected, onSelect, }) => {
    const theme = useTheme();
    return (React.createElement(PeekAccordionCard, { expanded: selected, onChange: () => onSelect(value), alwaysShowDetails: true, sx: selected
            ? {
                borderColor: theme.palette.teal[500],
                backgroundColor: SELECTED_BACKGROUND,
                "& .MuiButtonBase-root.MuiAccordionSummary-root": { backgroundColor: SELECTED_BACKGROUND },
            }
            : { borderColor: theme.palette.grey[100] }, summaryContent: React.createElement(PeekStack, { direction: "row", gap: 1.4, alignItems: "center", sx: { px: 0.6, py: 0.5 } },
            React.createElement(PeekRadio, { "data-testid": `format-option-${value}`, checked: selected, value: value, disableRipple: true, sx: { p: 0 }, icon: React.createElement(RadioMark, { borderColor: theme.palette.grey[300] }), checkedIcon: React.createElement(RadioMark, { borderColor: theme.palette.teal[500], dotColor: theme.palette.teal[500] }) }),
            React.createElement(PeekTypography, { variant: "h4", fontWeight: "fontWeightMedium" }, title)), detailsContent: React.createElement(PeekTypography, { variant: "body1", color: "info.main", sx: { display: "block", pl: 4.6, pr: 1.6, pt: 0.3, pb: 1.5 } }, description) }));
};
export default FormatOptionCard;
